module.exports = __webpack_public_path__ + "static/img/1.70cfe6fe.png";